const imagesContainer = document.querySelector(".pdp-product-gallery");
const mainImages = document.querySelector(".product__media-list");
const images = document.querySelectorAll(".product__media-item");
const navItems = document.querySelectorAll(".product-gallery__nav-item");
const prevButton = document.querySelector('button[name="previous"]');
const nextButton = document.querySelector('button[name="next"]');
const imagesWidth =
  images.length > 0
    ? images[0].offsetWidth
    : document.querySelector(".product__media-wrapper").offsetWidth;
// const isMobile = window.matchMedia(
//   "(max-width: 749px)"
// ).matches;
const options = {
  root: mainImages,
  rootMargin: "0px",
  threshold: 0.999,
};

if (isMobile) {
  navItems.forEach(item =>
    item.addEventListener("click", onNavItemClick.bind(this))
  );
  prevButton
    ? prevButton.addEventListener("click", onButtonClick.bind(this))
    : null;
  nextButton
    ? nextButton.addEventListener("click", onButtonClick.bind(this))
    : null;
  if (images && images.length > 0) {
    loopingImages();
    runVisObserver(images);
  }

  function handleIntersection(entries) {
    entries.map(entry => {
      entry.target.classList.remove("product__media-item_image--active");
      if (entry.isIntersecting) {
        if (entry.target.id == "clonedlast") {
          setTimeout(() => {
            mainImages.scrollLeft = imagesWidth * images.length;
          }, 72);
        }
        if (entry.target.id == "clonedfirst") {
          setTimeout(() => {
            mainImages.scrollLeft = imagesWidth;
          }, 72);
        }
        if (entry.target.id == "") {
          entry.target.classList.add("product__media-item_image--active");
          setActiveThumbnail(entry.target);
        }
      }
    });
  }

  function runVisObserver(elems) {
    const observer = new IntersectionObserver(handleIntersection, options);
    elems.length > 1
      ? elems.forEach(image => observer.observe(image))
      : observer.observe(elems);
  }

  if (images && images.length > 0) {
    scrollToActive(images[0]);
  }

  function loopingImages() {
    const firstImage = images[0];
    const lastImage = images[images.length - 1];
    const clonedFirst = firstImage.cloneNode(true);
    const clonedLast = lastImage.cloneNode(true);

    clonedFirst.id = "clonedfirst";
    clonedLast.id = "clonedlast";

    mainImages.appendChild(clonedFirst);
    mainImages.prepend(clonedLast);

    runVisObserver(clonedFirst);
    runVisObserver(clonedLast);
  }

  function scrollToActive(image) {
    image.scrollIntoView(false);
  }

  function onNavItemClick(event) {
    const mediaId = event.target.closest("li");
    scrollToActive(
      Array.from(images).find(
        item => item.dataset.altMediaId === mediaId.dataset.mediaId
      )
    );
  }

  function setActiveThumbnail(elem) {
    navItems.forEach(item => {
      item.classList.remove("product-gallery__nav-item--active");
      item.classList.add("product-gallery__nav-item--inactive");

      if (item.dataset.mediaId === elem.dataset.altMediaId) {
        item.classList.remove("product-gallery__nav-item--inactive");
        item.classList.add("product-gallery__nav-item--active");
      }
    });
  }

  function findCurrentIndex() {
    return Array.from(images).findIndex(item =>
      item.classList.contains("product__media-item_image--active")
    );
  }

  function onButtonClick(event) {
    event.preventDefault();
    let index = findCurrentIndex();
    const imageIndex = images.length - 1;

    if (event.currentTarget.name === "next") {
      if (index >= imageIndex) {
        index = 0;
      } else {
        index++;
      }
    } else if (event.currentTarget.name === "previous") {
      if (index < 1) {
        index = imageIndex;
      } else {
        index--;
      }
    }
    scrollToActive(images[index]);
  }
}
